import copy from "copy-to-clipboard";
import { FocusEvent, useState } from "react";
import { FaCheck, FaCopy } from "react-icons/fa";

export default function UrlCopyElement({ url }: { url: string }) {
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const handleFocus = (event: FocusEvent<HTMLInputElement>) =>
    event.target?.select();

  return (
    <div className="flex bg-slate-100 rounded-md border-slate-400 border text-slate-700 overflow-hidden font-mono">
      <input
        onFocus={handleFocus}
        className="font-mono bg-slate-100 rounded-md rounded-r-none w-full overflow-hidden px-3 py-1 text-sm focus-visible:outline-none"
        value={url}
        onChange={() => {}}
      />
      <div
        onClick={() => {
          setIsCopied(true);
          copy(url);
          setTimeout(() => {
            setIsCopied(false);
          }, 2000);
        }}
        className="flex justify-center items-center py-1 px-4 border-slate-400 border-l cursor-pointer"
      >
        {!isCopied && <FaCopy size={15} />}
        {isCopied && <FaCheck size={15} className="text-emerald-500" />}
      </div>
    </div>
  );
}
